import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { Button, LinearProgress, DialogActions, DialogTitle, Grid } from '@material-ui/core';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { createAccount, getAccounts } from '../../../services';
import FormInput from '../../ReactHookForm/FormInput/FormInput';


const AccountRefForm = ({ showModal, setShowModal, onSuccess , onFailure }) => {

    const FORM_FIELDS = {
        ACCOUNT_NAME: 'accountName',
    };
    const formValidationSchema = Yup.object().shape({
        [FORM_FIELDS.ACCOUNT_NAME]: Yup.string()
            .required('An Account Name is Required')
            .default(''),
    });


    const [isSubmitting, setIsSubmitting] = useState(false);

   const onSubmit = async (values) => {
        setIsSubmitting(true);
        try {
            const response = await createAccount(values);
            onSuccess(response);
        } catch (error) {
            onFailure(error);
        }
        setIsSubmitting(false);
        setShowModal(false);
    }

    const formMethods = useForm({
        resolver: yupResolver(formValidationSchema),
    });

    const {
        handleSubmit,
        formState: { errors: formErrors },
        control,
        reset,
      } = formMethods;

    return (
        <Dialog
            open={showModal}
            maxWidth="lg"
            onClose={() => setShowModal(false)}
            aria-labelledby="agent-create-title"
            contentStyle={{ width: '100%', maxWidth: 'none' }}
        >
            <DialogTitle>
                Create Account
            </DialogTitle>
            <DialogContent
                dividers
                style={{
                    minWidth: 500,
                    borderTop: '0.8px solid #ddd',
                    borderBottom: '0.8px solid #ddd',
                    paddingTop: 20,
                    pointerEvents: isSubmitting ? 'none' : 'auto',
                    opacity: isSubmitting ? 0.5 : 1,
                }}
            >
                <FormProvider {...formMethods} schema={formValidationSchema}>
                    <form>
                        <Grid item xs={12}>
                            <FormInput
                                isFixed
                                type="text"
                                name={FORM_FIELDS.ACCOUNT_NAME}
                                label="Account Name"
                            />
                        </Grid>
                    </form>
                </FormProvider>
                <div
                    style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: 25,
                    }}
                >
                    <Button
                        onClick={() => setShowModal(false)}
                        variant="contained"
                        style={{ backgroundColor: '#315382', color: 'white' }}
                    >
                        Cancel
                    </Button>
                    <Button
                        disabled={isSubmitting}
                        type="submit"
                        variant="contained"
                        style={{ backgroundColor: '#315382', color: 'white' }}
                        onClick={handleSubmit(onSubmit)}
                    >
                        Create
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

AccountRefForm.defaultProps = {};
AccountRefForm.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    client: PropTypes.object.isRequired,
  //onFailure: PropTypes.func,
};

export default AccountRefForm;
